import ajax from "./ajax";
import g from "./globals";
import L10N from "./l10n";
import Logger from "./Logger";

const logger = new Logger(__filename);

let instances = {};
// TODO: dict = true como parametro
const get = name => {
  let result = null;
  let instance = null;

  if (typeof name === "string") {
    instance = instances[name];
  } else if (name) {
    const translates = new L10N({}, g.locale);
    if (Array.isArray(name)) {
      name.forEach(dict => {
        translates.setup(dict);
      });
    } else {
      translates.setup(name);
    }
    instance = result = translates;
  }

  if (instance) {
    result = new Promise(resolve => resolve(instance));
  } else {
    result = instances[name] = new Promise(resolve => {
      const url = `${g.staticContent}/mkt/dicts/${name}.json?ts=${g.lastStaticSyncTimestamp}`;
      ajax.get(url, dict => {
        if (/Failed to fetch/i.test(dict)) {
          logger.error(`Missing dictionary ${name}`);
          return resolve({ dict: {} });
        }
        const l10n = new L10N(dict || {}, g.locale);
        instances[name] = l10n;
        resolve(l10n);
      });
    });
  }

  return result;
};

const flush = () => {
  instances = {};
};

export default { get, flush };
